import React, { useEffect, useRef, useState } from 'react'

const MAX_LINES = 3

export const ShowMoreText = ({ text = [] }) => {
    const [isExpanded, setIsExpanded] = useState(false)
    const [isOverflow, setIsOverflow] = useState(false)

    const textRef = useRef(null)

    const displayText = Array.isArray(text) ? text.join(', ') : ''

    useEffect(() => {
        if (!textRef.current) return

        const el = textRef.current
        const style = window.getComputedStyle(el)
        const lineHeight = parseFloat(style.lineHeight)

        if (!lineHeight) return

        const lines = el.scrollHeight / lineHeight
        setIsOverflow(lines > MAX_LINES)
    }, [displayText])

    if (!Array.isArray(text) || !text.length) return null

    return (
        <div>
            <div
                ref={textRef}
                style={{
                    overflow: 'hidden',
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: isExpanded ? 'unset' : MAX_LINES,
                    lineHeight: '22px'
                }}
            >
                {displayText}
            </div>

            {isOverflow && (
                <small
                    className="text-primary cursor-pointer"
                    onClick={() => setIsExpanded(prev => !prev)}
                >
                    {isExpanded ? 'show less' : 'show more'}
                </small>
            )}
        </div>
    )
}
